<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section v-if="text.title" class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{ $t(text.title) }}
        </p>
      </section>
      <b-field :label="$t(label)">
        <b-input v-model="code" ref="codeInput"/>
      </b-field>
      <div class="columns is-multiline mgb-20px max-height-30-vh overflow-x-scroll">
        <div v-for="code in text.codes" :key="code.code" class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer" @click="ajout(code.code)">
            {{code.code}}
          </p>
          <p class="has-text-default">
            {{ $t(code.title) }}
            <br>
            <span v-if="code.subtitle" class="is-italic is-size-7">
              {{ $t(code.subtitle)}}
            </span>
          </p>
        </div>
      </div>
      <error-msg-component
        :error="!!text.warningMessage"
        :canClose="true"
        :title="text.warningMessage.title"
        :titreMessageErreurEcran="text.warningMessage.content" />
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.edit') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
<!--
                  Documentation

Ce composant gère le contenu d'une pop up pour les générations de code.
Tous les textes en dessous de l'input sont généré a partir d'un tableau.

Paramètres:
value:
  est obligatoire.
  correspond a la valeur du champ de saisi (v-model)

label:
  est obligatoire
  correspond au label pour l'input dans la modal.

text:
  est obligatoire
  contient :
        titre: le titre en haut de la modal
        codes: correspond a tous les textes affichés en dessous de l'input.
        warningMessage: correspond a un message de prevention qui n'est pas obligatoire
 -->
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    text: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      code: null,
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    save() {
      this.$emit('input', this.code);
      this.$parent.close();
    },
    ajout(text) {
      this.code += text;
    },
  },
  mounted() {
    this.$refs.codeInput.focus();
    this.code = this.value;
  },
};
</script>
